import React, { FC, PropsWithChildren } from 'react'

import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { NavigationCounter } from '../Navigation/NavigationCounter/NavigationCounter'

export const EdnaUnreadMessageCount: FC<PropsWithChildren> = ({ children }) => {
  const { unreadMessageSupportEdna } = useShallowEqualSelector(
    ({ userReducer: { unreadMessageSupportEdna } }) => ({
      unreadMessageSupportEdna,
    })
  )

  if (unreadMessageSupportEdna > 0) {
    return (
      <NavigationCounter counter={unreadMessageSupportEdna}>
        {children}
      </NavigationCounter>
    )
  }

  return children
}
